export default function PowerMark() {
  return (
    <svg
      fill='none'
      height='23'
      viewBox='0 0 22 23'
      width='22'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M13.9023 0C17.2541 0.000101782 19.4008 1.7651 20.582 3.79004C21.6789 5.67034 21.9648 7.76391 21.9648 8.99023C21.9648 10.2449 21.6668 12.1915 20.4707 13.9004C19.1732 15.754 17.0032 17.0527 13.9023 17.0527V12.0488C15.4351 12.0488 16.0458 11.4936 16.3701 11.0303C16.7955 10.4224 16.9609 9.58909 16.9609 8.99023C16.9609 8.36295 16.7839 7.21163 16.2588 6.31152C15.8182 5.55632 15.1841 5.00497 13.9023 5.00488H7.83887C8.74639 6.84718 9.1023 8.98765 9.38281 10.6777C9.39501 10.7512 9.407 10.8238 9.41895 10.8955C9.78957 13.1193 10.0857 14.6699 10.7373 15.7363C11.0179 16.1954 11.3367 16.5061 11.7422 16.7217C12.1618 16.9448 12.8251 17.1455 13.9023 17.1455V22.1504C12.1992 22.1504 10.689 21.8299 9.39258 21.1406C8.08243 20.444 7.14188 19.4513 6.4668 18.3467C5.25345 16.3612 4.83742 13.8577 4.51855 11.9365C4.50637 11.8631 4.49437 11.7904 4.48242 11.7188C4.11177 9.49486 3.81676 7.94341 3.16504 6.87695C2.88446 6.41786 2.56471 6.10818 2.15918 5.89258C1.73956 5.66951 1.07713 5.46779 0 5.46777V0H13.9023Z'
        fill='#693AF2'
      />
    </svg>
  )
}
